import { memo } from "react";

import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import AIAgentTrackingService from "app/pages/sales-intelligence/modules/ai-agent/services/tracking/trackingService";

import { ContextualSuggestionsStrategy } from "../../components/message-strategy";
import { AnimatedContextualSuggestions } from "../../components/message-strategy/AnimatedContextualSuggestions";
import { useContextualSuggestionsList } from "../../hooks/useContextualSuggestionsList";
import { useIsChatFetching } from "../../hooks/useIsChatFetching";

type Props = {
    onSuggestionClick: (suggestionText: string) => void;
};

const ContextualSuggestionsContainer = ({ onSuggestionClick }: Props) => {
    const suggestionsList = useContextualSuggestionsList();

    const isChatFetching = useIsChatFetching();

    const isVisible = suggestionsList.length > 0 && !isChatFetching;

    const handleOnSuggestionClick = (suggestionText: string): void => {
        AIAgentTrackingService.leadGenerator.trackContextualSuggestionClick(suggestionText);

        onSuggestionClick(suggestionText);
    };

    const handleOnShowMoreClick = (): void => {
        AIAgentTrackingService.leadGenerator.trackShowMoreClick();
    };

    return (
        <AnimatedContextualSuggestions isVisible={isVisible}>
            <ContextualSuggestionsStrategy
                suggestions={suggestionsList}
                onSuggestionClick={handleOnSuggestionClick}
                onShowMoreClick={handleOnShowMoreClick}
            />
        </AnimatedContextualSuggestions>
    );
};

const WithErrorBoundary = (props: Props) => {
    return (
        <ErrorBoundaryWithLogging fallback={null}>
            <ContextualSuggestionsContainer {...props} />
        </ErrorBoundaryWithLogging>
    );
};

export default memo(WithErrorBoundary);
